import { Component, OnInit, Input } from '@angular/core';
import { CellType } from '@amobee/component-library';
import { TableConfigs, ToolBarConfigs } from '../../../../../common/components/data-table/data-table.component';
import { Router } from '@angular/router';
import { PlannerEndpoints } from '../../../../constants/planner-endpoints.const';

@Component({
  selector: 'advertiser-list',
  templateUrl: './advertiser-list.component.html',
  styleUrls: ['./advertiser-list.component.scss']
})
export class AdvertiserListComponent implements OnInit {

  @Input('marketInfo') public marketInfo: any;

  constructor(private router: Router) { }

  ngOnInit() { }

  public tableConfigs: TableConfigs = {
    disableSorting: false,
    defaultSort: {
      id: 'name',
      desc: false
    },
    uniqueIdAccessor: 'objectId',
    pageSize: 25, // default to 25
    isSelectionEnabled: false,
    isPaginationEnabled: true,
    showSummaryRow: false,
    stickyHeader: true,
    stickyColumnHeaders: true,
    endpoint: PlannerEndpoints.advertiserList,
    showCallToAction: true,
    callToActionProps: {
      type: 'EmptyTable',
      title: 'No Advertisers Found'
    }
  };
  public columns: any[] = [
    {
      Header: 'Advertiser Name',
      accessor: 'name',
      id: 'name',
      sticky: 'left',
      cellType: CellType.LINK,
      onLinkClick: (row) => {
        this.router.navigate(['advertiser-dashboard', row.original.objectId, 'planner-list'], { queryParams: { marketId: this.marketInfo.id } });
      },
      isActive: (row) => true,
      isRowActionColumn: true,
      rowActionButtons: [
        {
          buttonType: 'dropdown',
          //iconName: 'Overflow',
          items: [
            {
              label: 'Create New Plan',
              onClick: (props) => {
                this.router.navigate(['planner/new'], { queryParams: { advertiserId: props.row.original.objectId, marketId: this.marketInfo.id } });
              }
            },
          ]
        }
      ]
    },
    {
      Header: 'ID',
      accessor: 'objectId',
      id: 'objectId',
      disableSortBy: true
    },
    {
      Header: 'No. of Plans',
      accessor: 'count',
      id: 'count',
      disableSortBy: true
    }
  ];

  public toolbarConfigs: ToolBarConfigs = {
    isSearchEnable: true,
    toolbarOptions: {
      isRefreshVisible: true
    }
  }

}
